(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5RvcM", function(module, exports) {

var $2VdAa = parcelRequire("2VdAa");
const $444a1bb032615f24$var$fieldSelector = ".f-text, .f-single-select, .f-checkbox, .f-file, .f-textarea, .f-switch";
const $444a1bb032615f24$var$handleFormSubmit = (form)=>{
    form.addEventListener("submit", (event)=>{
        const fields = [
            ...form.querySelectorAll($444a1bb032615f24$var$fieldSelector)
        ].map((field)=>new (0, $2VdAa.Field)(field));
        const isValid = form.checkValidity();
        fields.forEach((field)=>field.validate());
        if (!isValid) {
            $444a1bb032615f24$var$scrollToInvalid(form);
            event.preventDefault();
            return;
        }
        // Prevent double submit
        form.querySelectorAll(`button[type="submit"`).forEach((button)=>{
            button.setAttribute("disabled", "");
        });
    });
};
function $444a1bb032615f24$var$scrollToInvalid(form) {
    const invalidInputs = Array.from(form.querySelectorAll(":invalid")); // set up so you can use any custom invalid classes you're adding to your elements, as well
    invalidInputs.sort((a, b)=>a.getBoundingClientRect().top - b.getBoundingClientRect().top); // sort inputs by offset from top of viewport (handles issues with multi-column layouts, where the first element in the markup isn't necessarily the highest on the page)
    if (invalidInputs[0]) invalidInputs[0].scrollIntoView({
        block: "center"
    }); // scroll first (top) input into center of view,
}
const $444a1bb032615f24$var$initForms = ()=>{
    const formsSelector = "form.--validate:not(.--initialized)";
    const forms = document.querySelectorAll(formsSelector);
    forms.forEach((form)=>{
        /**
         * Setting noValidate turns off the native client-side validation,
         * freeing us up to do whatever we want. Turning off validation with JavaScript ensures
         * the default validation still runs if JavaScript never executes for whatever reason.
         * It also prevents showing our invalid style preemptively.
         */ form.noValidate = true;
        const getFields = ()=>[
                ...form.querySelectorAll($444a1bb032615f24$var$fieldSelector)
            ].filter((field)=>!field.classList.contains("--validating")).map((field)=>new (0, $2VdAa.Field)(field));
        getFields().forEach((field)=>field.handleInputEvents());
        $444a1bb032615f24$var$handleFormSubmit(form);
        form.classList.add("--initialized");
        form.addEventListener("inputsReinit", ()=>{
            getFields().forEach((field)=>field.handleInputEvents());
        });
    });
};
$444a1bb032615f24$var$initForms();
document.addEventListener("baseformReinit", $444a1bb032615f24$var$initForms);

});
parcelRegister("2VdAa", function(module, exports) {

$parcel$export(module.exports, "Field", function () { return $220b70d2cec1c1c1$export$a455218a85c89869; });

var $e3qbH = parcelRequire("e3qbH");
const $220b70d2cec1c1c1$var$events = [
    "blur",
    "change"
];
class $220b70d2cec1c1c1$export$a455218a85c89869 {
    field;
    input;
    error;
    constructor(field){
        this.field = field;
        this.input = field.querySelector("input, select, textarea");
        this.error = new (0, $e3qbH.ErrorField)(this.field.querySelector(".f-error") ?? null);
        this.init();
    }
    init() {
        this.field.addEventListener("validate", ()=>{
            this.validate();
        });
    }
    setDisabled(disabled) {
        this.input?.toggleAttribute("disabled", disabled);
        this.field.classList.toggle("--disabled", disabled);
    }
    setActive(active) {
        this.field.classList.toggle("--active", active);
    }
    setInvalid(invalid) {
        this.field.classList.toggle("--invalid", invalid);
    }
    /**
     * returns whether a form will validate when it is submitted, without having to submit it.
     */ isValid() {
        return this.input?.checkValidity() ?? false;
    }
    validate() {
        if (!this.input) return;
        const isValid = this.isValid();
        const message = this.getValidationMessage();
        this.setInvalid(!isValid);
        this.error.toggle(!isValid);
        this.error.setTitle(message);
        this.input.setAttribute("aria-invalid", String(!isValid));
    }
    handleInputEvents = ()=>{
        this.field.classList.add("--validating");
        $220b70d2cec1c1c1$var$events.forEach((event)=>{
            this.input?.addEventListener(event, ()=>{
                this.validate();
            });
        });
    };
    getValue() {
        return this.input?.value ?? "";
    }
    getValidationMessage = ()=>{
        if (!this.input) return "";
        const { validity: validity, dataset: dataset } = this.input;
        let message = this.input.validationMessage;
        // This could be expanded for any validity type and change message.
        // Since I doubt this will be ever used, I will just leave it only for patternMismatch.
        // But feel free to expand this.
        if (validity.patternMismatch && dataset.validityPatternMismatch) message = dataset.validityPatternMismatch;
        if (validity.valueMissing && dataset.validityValueMissing) message = dataset.validityValueMissing;
        return message;
    };
}

});
parcelRegister("e3qbH", function(module, exports) {

$parcel$export(module.exports, "ErrorField", function () { return $a3b5a8db91693d32$export$a093dca7d0282216; });
class $a3b5a8db91693d32$export$a093dca7d0282216 {
    errorItem;
    title;
    constructor(errorItem){
        this.errorItem = errorItem;
        this.title = errorItem?.querySelector(".f-error__title") ?? null;
    }
    toggle(show) {
        this.errorItem?.classList.toggle("--show", show);
    }
    setTitle(title) {
        if (this.title) this.title.innerHTML = title;
    }
}

});



})();
//# sourceMappingURL=base-form.907b18b0.js.map
